import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, API } from "@/App";
import axios from "axios";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser, checkAuth } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace('#', ''));
    const sessionToken = params.get('session_token');

    if (!sessionToken) {
      navigate("/", { replace: true });
      return;
    }

    // The cookie was already set by the backend redirect.
    // Just verify the session and get user data.
    const verifySession = async () => {
      try {
        const resp = await axios.get(`${API}/auth/me`, { withCredentials: true });
        setUser(resp.data);
        const pathname = window.location.pathname || "";
        const search = window.location.search || "";
        const isUpgradeReturn = search.includes("upgrade=pro");
        const dest = isUpgradeReturn
          ? pathname + search
          : resp.data.onboarding_completed
            ? "/dashboard"
            : "/onboarding?step=calendar";
        window.history.replaceState(null, '', dest);
        navigate(dest, { replace: true, state: { user: resp.data } });
      } catch (err) {
        console.error("Auth verification failed:", err);
        navigate("/", { replace: true });
      }
    };

    verifySession();
  }, [navigate, setUser, checkAuth]);

  return (
    <div className="min-h-screen mesh-bg flex items-center justify-center">
      <div className="glass-card rounded-2xl p-8 text-center">
        <div className="w-8 h-8 border-2 border-slate-300 border-t-slate-700 rounded-full animate-spin mx-auto mb-4" />
        <p className="text-slate-500 font-body text-sm">Signing you in...</p>
      </div>
    </div>
  );
}
